import type { HTMLAttributes, ReactNode, Ref } from "react";

import { tv, type VariantProps } from "tailwind-variants";

import { Listbox, type ListboxProps } from "./Listbox";

export const popoverVariants = tv({
	slots: {
		base: "absolute w-full border border-primary-border bg-background",
	},
	variants: {
		size: {
			md: "rounded-md p-2",
			lg: "rounded-lg p-3",
			xl: "rounded-xl p-4",
		},
	},
});

type PopoverVariant = VariantProps<typeof popoverVariants>;

export type PopoverProps = PopoverVariant &
	Omit<HTMLAttributes<HTMLDivElement>, "children"> & {
		readonly className?: string;
		readonly listbox?: Omit<ListboxProps, "size">;
		readonly ref?: Ref<HTMLDivElement>;
		readonly close: () => void;
		readonly children?: ReactNode | (({ close }: { close: () => void }) => ReactNode);
	};

export function Popover({
	size = "md",
	className,
	listbox,
	children,
	ref,
	close,
	...props
}: PopoverProps) {
	const { base } = popoverVariants({ size });

	return (
		<div ref={ref} className={base({ className })} {...props}>
			{listbox && <Listbox {...listbox} size={size} />}
			{!listbox && typeof children === "function" && children({ close })}
			{!listbox && typeof children !== "function" && children}
		</div>
	);
}
